module.exports = __webpack_public_path__ + "img/sun1.371d02e5.svg";